"use client";

import { Box, Flex, Skeleton } from "@chakra-ui/react";
import { useThemeTokens } from "@/lib/theme/tokens";
import {
  PublicListingPageSkeleton,
  PublicListingRowsSkeleton,
  PublicListingToolbarSkeleton,
} from "@/views/shared/public-listing";

export const ClassesPageSkeleton = ({
  hideHero = false,
}: {
  hideHero?: boolean;
}) => {
  const theme = useThemeTokens();

  return (
    <PublicListingPageSkeleton
      hideHero={hideHero}
      toolbar={<PublicListingToolbarSkeleton variant="classes" />}
    >
      <PublicListingRowsSkeleton count={5}>
        {(index, isLast) => (
          <Box
            key={index}
            py={{ base: 5, md: 6 }}
            borderBottomWidth={isLast ? 0 : "1px"}
            borderColor={theme.borderGlass.subtle}
          >
            <Flex
              direction={{ base: "column", lg: "row" }}
              align={{ base: "stretch", lg: "flex-start" }}
              gap={{ base: 4, lg: 8 }}
            >
              <Box flexShrink={0} w={{ base: "100%", lg: "148px" }}>
                <Skeleton height="12px" width="72px" mb={1} borderRadius="4px" />
                <Skeleton height="16px" width="132px" borderRadius="4px" />
                <Skeleton
                  height="24px"
                  width="88px"
                  mt={2.5}
                  borderRadius="full"
                />
              </Box>

              <Flex direction="column" flex={1} minW={0} gap={2}>
                <Skeleton
                  height={{ base: "24px", md: "28px" }}
                  width={{ base: "88%", md: "70%" }}
                  borderRadius="4px"
                />
                <Skeleton height="16px" width="100%" borderRadius="4px" />
                <Skeleton
                  height="16px"
                  width={{ base: "92%", md: "78%" }}
                  borderRadius="4px"
                />
                <Skeleton height="16px" width="42%" borderRadius="4px" />
              </Flex>

              <Flex
                flexShrink={0}
                direction={{ base: "row", lg: "column" }}
                align={{ base: "center", lg: "flex-end" }}
                justify={{ base: "space-between", lg: "flex-start" }}
                gap={3}
                w={{ base: "100%", lg: "auto" }}
                minW={{ lg: "148px" }}
                pt={{ lg: 1 }}
              >
                <Skeleton height="32px" width="96px" borderRadius="8px" />
                <Skeleton height="14px" width="72px" borderRadius="4px" />
              </Flex>
            </Flex>
          </Box>
        )}
      </PublicListingRowsSkeleton>
    </PublicListingPageSkeleton>
  );
};
